import { module } from "angular";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { IGuardCompany, IResponse } from "App/Modules/Models";
import type { IGuardCompaniesRepository } from "./IGuardCompaniesRepository";

export default class GuardCompaniesRepository implements IGuardCompaniesRepository {
    public static $inject: string[] = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getSiteGuardCompanies(siteId: string): Observable<IResponse<IGuardCompany[]>> {
        return this.httpService.get<IGuardCompany[]>(`sites/${siteId}/guardCompanies`);
    }
}

module("mmRepositories").service("mmGuardCompaniesRepository", GuardCompaniesRepository);
